module.exports = __webpack_public_path__ + "img/1Reihe_2.ae4a9987.jpg";